import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { CreateProjectSuccessResponse } from '../../../../../types/api/project/create-project-success-response';
import './company-admin-project-add.css';
import { showLoadingAlertMessage } from '../../../../../../../utils/show-loading-alert-message/show-loading-alert-message';
import { networkCall } from '../../../../../../../utils/network-call/network-call';
import { showDefaultErrorMessages } from '../../../../../../../utils/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../../../redux/reducer/alert-message.reducer';
import { AlertMessages } from '../../../../../../../enums/alert-messages.enum';
import { DefaultErrorResponse } from '../../../../../../../types/api/error/default-error-response/default-error-respose.type';
import { ValidationErrorResponseData } from '../../../../../../../types/api/error/validation-error-response-data/validation-error-response-data.type.';
import { tranformAPIValidationErrorToAntDValidationMessage } from '../../../../../../../utils/validation/transform-api-validation-errors-to-antd-validation-messsages';
import { setSelectedMenuItemKeys } from '../../../../../../../redux/reducer/antd-layout-info.reducer';
import { CMSButton } from '../../../../../../../components/cms/button/cms-button.';
import { getImageUrl } from '../../../../../../../utils/image-helper/get-image-url';

export const CompanyAdminProjectAdd = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [moduleChechboxes, setModuleChechboxes] = useState({
        workInstructionModule: {
            error: '',
            value: false
        },
        processEditorModule: {
            error: '',
            value: false
        },
        modelSpaceModule: {
            error: '',
            value: false
        },
        layerEditorModule: {
            error: '',
            value: false
        }
    });

    const resetCheckboxErrors = () => {
        const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
        for (const prop in _moduleChechboxes) {
            _moduleChechboxes[prop as keyof typeof moduleChechboxes].error = '';
        }
        setModuleChechboxes(_moduleChechboxes);
    };

    const handleCheckboxChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
        for (const prop in _moduleChechboxes) {
            _moduleChechboxes[prop as keyof typeof moduleChechboxes].error = '';
        }
        _moduleChechboxes[e.target.name as keyof typeof _moduleChechboxes].value = e.target.checked;
        setModuleChechboxes(_moduleChechboxes);
    };

    const handleFinish = async (values: any) => {

        if (moduleChechboxes.processEditorModule.value === true && moduleChechboxes.modelSpaceModule.value === false) {
            const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
            _moduleChechboxes.modelSpaceModule.error = 'A folyamatszerkesztő modulhoz a modelltér modul kiválasztása kötelező.'
            setModuleChechboxes(_moduleChechboxes);
            return;
        }

        if (moduleChechboxes.layerEditorModule.value === true && moduleChechboxes.modelSpaceModule.value === false) {
            const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
            _moduleChechboxes.modelSpaceModule.error = 'A rétegszerkesztő modulhoz a modelltér modul kiválasztása kötelező.'
            setModuleChechboxes(_moduleChechboxes);
            return;
        }

        showLoadingAlertMessage();

        const response = await networkCall('/projects', {
            method: 'POST',
            body: {
                name: values.name,
                description: values.description,
                workInstructionModule: moduleChechboxes.workInstructionModule.value,
                processEditorModule: moduleChechboxes.processEditorModule.value,
                modelSpaceModule: moduleChechboxes.modelSpaceModule.value,
                layerEditorModule: moduleChechboxes.layerEditorModule.value
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if(messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: AlertMessages.UnknownErrorTryAgain
        };

        if (response?.status === 201) {
            const res: AxiosResponse<CreateProjectSuccessResponse> = response;

            alertMessageState.alertMessageText = 'Mentés sikeres.';
            alertMessageState.alertMessageType = 'success';
            navigate(`/cms/company-admin/projects/${ res.data.project.id }/modules`);

        } else if (response?.status === 400) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {

                case 1000:
                    const _res: AxiosResponse<DefaultErrorResponse<ValidationErrorResponseData[]>> = response;
                    alertMessageState.alertMessageText = 'Hibásan megadott beviteli mezők.';
                    const validationErrors = tranformAPIValidationErrorToAntDValidationMessage(_res.data.data!);
                    form.setFields(validationErrors);

                    const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
                    _res.data.data?.forEach(validationError => {
                        _moduleChechboxes[validationError.field as keyof typeof moduleChechboxes].error = validationError.errors.join(' ');
                    });
                    setModuleChechboxes(_moduleChechboxes);
                    break;

            }

        }

        dispatch(showAlertMessage(alertMessageState));
    }

    useEffect(() => {
        dispatch(setSelectedMenuItemKeys(['company-admin-projects']));
    }, [dispatch]);

    return (
        <>
            <div className="page-title">Új projekt hozzáadása</div>
            <Form
                form={form}
                onFinish={handleFinish}
                layout='vertical'
            >
    
                <Form.Item
                    label='Projekt neve'
                    name='name'
                    rules={[{required: true, message: 'Név megadása kötelező!'}]}
                    className='mb-2'
                >
                    <Input className='box-shadow-4-4-8-0 border-0' placeholder='Projekt neve' />
                </Form.Item>

                <Form.Item
                    label='Leírás'
                    name='description'
                    rules={[{required: true, message: 'Leírás megadása kötelező!'}]}
                    className='mb-2'
                >
                    <Input.TextArea
                        className='box-shadow-4-4-8-0 border-0'
                        placeholder='Leírás'
                        autoSize={{ minRows: 5 }}
                    />
                </Form.Item>

                <div className='box-shadow-4-4-8-0 py-2 company-admin-project-add-module-checkboxes-container'>
                    
                    <strong>Modulok</strong>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-2'>
                        <input
                            name='workInstructionModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.workInstructionModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Munkautasítás</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.workInstructionModule.error }</div>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-1'>
                        <input
                            name='processEditorModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.processEditorModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Folyamatszerkesztő</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.processEditorModule.error }</div>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-1'>
                        <input
                            name='modelSpaceModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.modelSpaceModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Modelltér</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.modelSpaceModule.error }</div>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-1'>
                        <input
                            name='layerEditorModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.layerEditorModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Rétegszerkesztő</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.layerEditorModule.error }</div>
  
                </div>             

                <Form.Item className='mt-4'>
                    <div className='d-flex justify-content-between'>
                        <Link to='/cms/company-admin/projects'>
                            <CMSButton text='Vissza' type='white' iconSrc={getImageUrl('back-icon.png')} />
                        </Link>
                        <CMSButton text='Mentés' iconSrc={getImageUrl('Save-icon.png')} htmlType='submit' />
                    </div>
                </Form.Item>
                        
            </Form>
        </>
    );
};